import React from "react";

function Footer() {
  return (
    <footer className="footer fixed-bottom top-and-bottom">
      <p className="text-center text-white">The Roofer's of MD, LLC</p>
      <span id="siteseal">
        <script
          async
          type="text/javascript"
          src="https://seal.godaddy.com/getSeal?sealID=3VWi26t6M7otnkgT1m0cen1Mq9B6BuxTP2rDlDPnJY7CPH2EHCqfXRj4udtQ"
        ></script>
      </span>
    </footer>
  );
}

export default Footer;
